// extracted by mini-css-extract-plugin
export default {"wrapper":"CallToActionItem-module__wrapper--tW9wL","feedbackLink":"CallToActionItem-module__feedbackLink--Xmnmf"};